import FormHeaderBlock from './FormHeaderBlock.jsx';
import FormHeaderProgress from '../../public/components/FormHeaderProgress.jsx';
import ThemedForm from './ThemedForm.jsx';

const EditableFormHeaderBlock = ({
    styles,
    className,
    onClickCover,
    onClickName,
    form,
    sections,
    imageOnly,
}) => {
    return (
        <ThemedForm styles={styles} scopeRoot={false}>
            <div className={`${imageOnly ? 'mb-0' : 'mb-6'}`}>
                {!!imageOnly && (
                    <div
                        className={`cursor-pointer relative group ${className}`}
                        onClick={onClickCover}
                    >
                        <div className="hidden text-white text-xl w-full h-full absolute bg-[#00000044] group-hover:flex items-center justify-center">
                            Edit
                        </div>
                        <FormHeaderBlock
                            styles={styles}
                            objectId={form?.id}
                            objectType="form"
                            className="min-h-24"
                        />
                    </div>
                )}


                {!!form && !!sections && !imageOnly && (
                    <div
                        onClick={onClickName}
                        className="cursor-pointer relative group"
                    >
                        <div className="hidden text-white text-xl w-full h-full absolute bg-[#00000044] group-hover:flex items-center justify-center">
                            Edit
                        </div>
                        <FormHeaderProgress
                            form={form}
                            visibleSections={[sections[0]?.section?.id]}
                            setVisibleSections={() => null}
                            sections={sections}
                            answers={[]}
                            hasSubmitted={false}
                            hasPaymentStep={false}
                            isOnPaymentStep={false}
                            onPaymentStepBack={() => null}
                        />
                    </div>
                )}
            </div>
        </ThemedForm>
    );
};

export default EditableFormHeaderBlock;
